<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .status-dot {
    width: utils.in_rem(12px);
    height: utils.in_rem(12px);
    border-radius: 50%;

    &.active {
      background-color: colors.get(accentStatusSeaGreen);
    }
    &.inactive {
      background-color: colors.get(primary_50);
    }

    border: 1px solid colors.get(interfaceWhite);
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";

  export let candidateStatus; // "active" or "inactive"
  export let tooltip;
</script>

<Tooltip
  placement="left"
  let:onmouseenter
  let:onmouseleave
  let:onblur
  let:onfocus
>
  <span slot="tooltip">{tooltip}</span>
  <div
    {onmouseenter}
    {onmouseleave}
    {onfocus}
    {onblur}
    role="button"
    tabindex="-1"
    class="status-dot {candidateStatus}"
  ></div>
</Tooltip>
